import { useEffect, useState } from "react";
import {
  getNotificationList,
  updateNotification,
} from "../../endpoints/notification.service";
import dayjs from "dayjs";
import CloseIcon from "../../assets/svg/CloseIcon";
import { referralRequestActionApi } from "../../endpoints/referral.service";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";
import { updatePrivacyReqest } from "../../endpoints/candidate.service";
import { EventType } from "./notification.types";
import { useDispatch, useSelector } from "react-redux";
import { updateNotificationCounts } from "@store/actions/notification.action";

const NotificationPage = () => {
  const dispatch = useDispatch();
  const unreadNotification = useSelector(
    (state) => state.notification?.notification || 0
  )
  const [notificationList, setNotificationList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingActionButtons, setIsLoadingActionButtons] =
    useState(undefined);

  const handleNotificationClick = ({
    notificationId,
    readStatus
  }) => {
    updateNotification({ notificationId }).then((res) => {
      const { success } = res;
      if (success) {
        if(!readStatus){
          const updatedCount = unreadNotification > 1 ? unreadNotification-1:0
          dispatch(updateNotificationCounts({notification:updatedCount}))
        }
        setNotificationList((prev) =>
          prev?.map((item) => {
            if (item?._id === notificationId) {
              return { ...item, status: "read" };
            } else {
              return item;
            }
          })
        );
      }
    });
  };

  useEffect(() => {
    fetchNotification();
  }, []);

  const fetchNotification = () => {
    getNotificationList()
      .then((res) => {
        setNotificationList(res?.data || []);
      })
      .finally(() => setIsLoading(false));
  };

  const notificationRequestAction = async ({
    requestId,
    action,
    notificationId,
    readStatus,
    type,
  }) => {
    try {
      setIsLoadingActionButtons({ notificationId, action });
      let data;
      if (type === EventType.ReferralDetailAccessRequest) {
        data = await updatePrivacyReqest({
          requestStatus: action,
          notificationId,
        });
      } else {
        data = await referralRequestActionApi({
          requestId,
          action,
          notificationId,
        });
      }
      await handleNotificationClick({notificationId,readStatus});
      if (data?.success) {
        fetchNotification();
      }
    } catch (e) {
      console.error("Action failed:", e);
    } finally {
      setIsLoadingActionButtons(undefined);
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow py-8 px-24">
      <h3 className="font-semibold text-xl">Notifications </h3>
      {isLoading ? (
        <div className="flex h-full w-full items-center justify-center">
          <LoadingAnimation color={"black"} />
        </div>
      ) : !notificationList ? (
        <div className="flex h-full w-full items-center justify-center font-medium">
          You're all caught up! No notifications for now.
        </div>
      ) : (
        <div className="flex flex-col py-4 overflow-y-scroll no-scrollbar">
          {notificationList?.map((notification, notificationIndex) => {
            return (
              <div key={notification?._id} className="flex">
                <div
                  onClick={() => {
                    if (
                      notification?.type === "Referral Invite" ||
                      notification?.type === "Candidate Invite"
                    ) {
                      return;
                    }
                    handleNotificationClick({notificationId:notification?._id,readStatus:notification?.status === 'read'});
                  }}
                  className={`flex flex-1 flex-col px-5 py-6 gap-1 cursor-pointer hover:bg-[#F7F7F7] ${
                    notificationIndex !== 0 ? "border-t" : ""
                  } ${
                    notification?.status === "unread"
                      ? "bg-light-white-700"
                      : "bg-white"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-2 font-semibold text-base text-charcoal">
                      {notification?.type}
                    </span>
                    <span className="text-sm text-light-black">
                      {dayjs(notification?.createdAt).format("MMMM DD, YYYY")}
                    </span>
                  </div>

                  <span className="font-medium text-xs text-light-black">
                    {notification?.message}
                  </span>
                  {notification?.status === "unread" &&
                    (notification?.type ===
                      EventType.ReferralDetailAccessRequest ||
                      notification?.type === EventType.PartnerAgencyRequest ||
                      (notification?.type === EventType.ReferralInvite &&
                        notification?.inviteStatus === "approved") ||
                      (notification?.type === EventType.CandidateInvite &&
                        notification?.inviteStatus === "approved")) && (
                      <div className="flex flex-col mt-4">
                        <div className="flex gap-2 mt-4">
                          <button
                            disabled={
                              isLoadingActionButtons?.notificationId ===
                              notification?._id
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              notificationRequestAction({
                                type: notification.type,
                                requestId: notification?.requestId,
                                action: "approved",
                                readStatus:notification?.status === 'read',
                                notificationId: notification?._id,
                              });
                            }}
                            className={`px-8 py-2 bg-black text-white rounded text-xs font-medium`}
                          >
                            Accept
                          </button>
                          <button
                            disabled={
                              isLoadingActionButtons?.notificationId ===
                              notification?._id
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              notificationRequestAction({
                                type: notification.type,
                                requestId: notification?.requestId,
                                action: "declined",
                                readStatus:notification?.status === 'read',
                                notificationId: notification?._id,
                              });
                            }}
                            className={`px-8 py-2 border border-gray-400 rounded text-xs font-medium `}
                          >
                            Reject
                          </button>
                        </div>
                      </div>
                    )}
                </div>
                <div className="flex mx-16 self-center w-6 h-6 border-2 justify-center items-center rounded-full border-light-grey cursor-pointer">
                  <CloseIcon className="w-4 h-4" fill={"#BABABA"} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NotificationPage;
